<template>
  <fieldset>
    <FormulateInput
      type="date"
      :name="fieldName"
      placeholder="yyyy-mm-dd"
      pattern="\d{4}-\d{2}-\d{2}"
      :label="i18n.form.labels[fieldName]"
      :help="helpText"
      :min="minDate"
      :max="maxDate || '9999-12-31'"
      :validation="dateValidation"
      :validation-messages="validationMessages"
    />
  </fieldset>
</template>

<script>
import moment from 'moment';

export default {
  name: 'FieldsDatePicker',
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    fieldName: {
      type: String,
      default: 'date',
    },
    minDate: {
      type: String,
      default: null,
    },
    maxDate: {
      type: String,
      default: null,
    },
    dateValidation: {
      type: String,
      default: null,
    },
    validationMessagesOverride: {
      type: Object,
      default: null
    }
  },
  computed: {
    helpText() {
      return typeof this.i18n.form.help !== 'undefined' &&
        typeof this.i18n.form.help[this.fieldName] !== 'undefined'
        ? this.i18n.form.help[this.fieldName]
        : '';
    },
    validationMessages() {
      if(this.validationMessagesOverride) return this.validationMessagesOverride
      const validationsObject = this.i18n?.form?.validations?.[this.fieldName];

      if (validationsObject) {
        return {
          ...validationsObject,
          after:
            this.minDate && typeof validationsObject.after === 'string'
              ? validationsObject.after.replaceAll(
                  '{date}',
                  moment(this.minDate).format('DD-MM-YYYY'),
                )
              : validationsObject.after,
        };
      }
      return '';
    },
  },
};
</script>
